"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var student_controller_1 = __importDefault(require("./student.controller"));
var student_nav_module_1 = __importDefault(require("./directives/student-nav/student-nav.module"));
var order_form_module_1 = __importDefault(require("./directives/order-form/order-form.module"));
var student_footer_nav_module_1 = __importDefault(require("./directives/student-footer-nav/student-footer-nav.module"));
var complete_setup_module_1 = __importDefault(require("./directives/complete-setup/complete-setup.module"));
var student_dashboard_module_1 = __importDefault(require("./dashboard/student-dashboard.module"));
var student_report_card_module_1 = __importDefault(require("./report-card/student-report-card.module"));
var student_account_module_1 = __importDefault(require("./account/student-account.module"));
var student_drives_module_1 = __importDefault(require("./drives/student-drives.module"));
var student_progress_report_module_1 = __importDefault(require("./student-progress-report/student-progress-report.module"));
var student_settings_module_1 = __importDefault(require("./settings/student-settings.module"));
var student_fees_module_1 = __importDefault(require("./fees/student-fees.module"));
var student_orders_module_1 = __importDefault(require("./orders/student-orders.module"));
var purchase_new_services_module_1 = __importDefault(require("./purchase-new-services/purchase-new-services.module"));
var order_module_1 = __importDefault(require("./order/order.module"));
var available_courses_module_1 = __importDefault(require("./available-courses/available-courses.module"));
var book_class_module_1 = __importDefault(require("./book-class/book-class.module"));
var classes_module_1 = __importDefault(require("./classes/classes.module"));
var past_classes_and_courses_1 = __importDefault(require("./past-classes-and-courses/past-classes-and-courses"));
var online_drivers_ed_success_module_1 = __importDefault(require("./online-drivers-ed-success/online-drivers-ed-success.module"));
var online_drivers_ed_module_1 = __importDefault(require("./online-drivers-ed/online-drivers-ed.module"));
var payment_methods_module_1 = __importDefault(require("./payment-methods/payment-methods.module"));
var notes_module_1 = __importDefault(require("./notes/notes.module"));
var files_module_1 = __importDefault(require("./files/files.module"));
var student_documents_module_1 = __importDefault(require("./documents/student-documents.module"));
var student_waitlist_module_1 = __importDefault(require("./waitlist/student-waitlist.module"));
var Policies_1 = require("../classes/Policies");
var School_1 = require("../classes/School");
var Cashier_1 = require("../classes/Cashier");
var Student_1 = require("../classes/Student");
var student_html_1 = __importDefault(require("./student.html"));
var Order_1 = require("../classes/Order");
var ThirdPartyLibraries_1 = require("../../DriveScout/Billing/ThirdPartyLibraries");
function getCurrentUser(AuthService, UserService, CreateOrderService, PoliciesModel, PolicyService, VueStoreFactory, OrderDetailsService, StudentUsermetaModel, ENV) {
    return __awaiter(this, void 0, void 0, function () {
        var u, usermeta, user, student, policyresponse, policies, school, cashier;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, AuthService.getCurrentUser()];
                case 1:
                    u = _a.sent();
                    return [4 /*yield*/, StudentUsermetaModel.index(u.id)];
                case 2:
                    usermeta = _a.sent();
                    VueStoreFactory.dispatch("auth/SET_USER_METADATA", usermeta);
                    UserService.setCurrentUser(u);
                    user = UserService.getCurrentUser();
                    student = new Student_1.Student(user);
                    return [4 /*yield*/, PoliciesModel.getAll()];
                case 3:
                    policyresponse = _a.sent();
                    policies = (0, Policies_1.createFromPolicyAPIResponse)(policyresponse);
                    school = new School_1.School(__assign(__assign({}, policyresponse.school), { policies: policies.toArray() }));
                    policies.setSchool(school);
                    school.setPolicies(policies);
                    cashier = new Cashier_1.Cashier(school, new Order_1.Order());
                    cashier.addStudent(student);
                    CreateOrderService.cashier(cashier);
                    PolicyService.setPolicies(policies);
                    VueStoreFactory.dispatch("SET_POLICIES", policyresponse);
                    if (cashier.school().billingGatway().name().toLowerCase() === "authorize") {
                        (0, ThirdPartyLibraries_1.initAcceptJS)(ENV);
                    }
                    if (cashier.school().billingGatway().name().toLowerCase() === "stripe") {
                        (0, ThirdPartyLibraries_1.initStripe)(ENV);
                    }
                    OrderDetailsService.configureBilling({
                        policy: policyresponse.policies.find(function (policy) { return policy.name === "billing"; }),
                    });
                    return [2 /*return*/, UserService.getCurrentUser()];
            }
        });
    });
}
getCurrentUser.$inject = [
    "AuthService",
    "UserService",
    "CreateOrderService",
    "PoliciesModel",
    "PolicyService",
    "VueStoreFactory",
    "OrderDetailsService",
    "StudentUsermetaModel",
    "ENV",
];
function config($stateProvider, $urlRouterProvider) {
    $stateProvider.state("drivecoach.student", {
        url: "/student",
        controller: student_controller_1.default,
        resolve: {
            currentUser: getCurrentUser,
        },
        controllerAs: "vm",
        template: student_html_1.default,
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider"];
exports.default = angular_1.default
    .module("student", [
    student_nav_module_1.default.name,
    student_footer_nav_module_1.default.name,
    complete_setup_module_1.default.name,
    student_dashboard_module_1.default.name,
    student_report_card_module_1.default.name,
    student_account_module_1.default.name,
    student_drives_module_1.default.name,
    student_progress_report_module_1.default.name,
    student_settings_module_1.default.name,
    student_fees_module_1.default.name,
    student_orders_module_1.default.name,
    purchase_new_services_module_1.default.name,
    order_form_module_1.default.name,
    order_module_1.default.name,
    available_courses_module_1.default.name,
    book_class_module_1.default.name,
    classes_module_1.default.name,
    past_classes_and_courses_1.default.name,
    online_drivers_ed_success_module_1.default.name,
    online_drivers_ed_module_1.default.name,
    payment_methods_module_1.default.name,
    notes_module_1.default.name,
    files_module_1.default.name,
    student_documents_module_1.default.name,
    student_waitlist_module_1.default.name,
])
    .config(config)
    .controller("StudentController", student_controller_1.default);
